import { SectionLayout } from '@/pages/shared-components/SectionLayout'
import { ApplicationsBreadcrumb } from '../ApplicationsBreadcrumbs'
import { AppAdminsSection } from './AppAdminsSection'
import { AppAgentsSection } from './AppAgentsSection'
import { AppCollaborationChannelsSection } from './AppCollaborationChannelsSection'
import { AppDetailsBanner } from './AppDetailsBanner'
import { AppEntityTypesSection } from './AppEntityTypesSection'
import { AppPipelinesSection } from './AppPipelinesSection'

export const AppDetailsPage = () => {
  return (
    <>
      <ApplicationsBreadcrumb title="Details" />
      <SectionLayout>
        <AppDetailsBanner />
        {/* <AppAdminsSection /> */}
        <AppEntityTypesSection />
        <AppCollaborationChannelsSection />
        <AppAgentsSection />
        <AppPipelinesSection />
      </SectionLayout>
    </>
  )
}
